// Mesma chave e encoding do AuthService (app/shared/auth/auth.service.ts):
// o FullLayoutComponent lê essa flag para esconder sidebar/navbar no wizard de
// primeiro acesso, então o React precisa gravá-la com o formato que o Angular lê.
const PRIMEIRO_ACESSO_KEY = 'primeiro_acesso';

/**
 * Grava sessionStorage['primeiro_acesso'] como JSON boolean, espelhando
 * `AuthService.savePrimeiroAcesso`. O `goHome` legado fazia essa escrita antes de
 * ir ao wizard; o redirect pós-login em React precisa reproduzi-la para que o
 * FullLayout renderize o wizard sem o chrome de layout.
 */
export function savePrimeiroAcesso(primeiroAcesso: boolean): void {
  try {
    sessionStorage.setItem(PRIMEIRO_ACESSO_KEY, JSON.stringify(primeiroAcesso));
  } catch {
    // Storage indisponível (modo privado, quota, etc.) — best-effort.
  }
}
